import { create } from "zustand";

export const useStoreCallActivity = create((set) => ({
  overviewData: null,
  bestTimesData: null,
  numberPerformanceData: null,

  setOverviewData: (data) => set({ overviewData: data }),
  clearOverviewData: () => set({ overviewData: null }),

  setBestTimesData: (data) => set({ bestTimesData: data }),
  clearBestTimesData: () => set({ bestTimesData: null }),

  setNumberPerformanceData: (data) => set({ numberPerformanceData: data }),
  clearNumberPerformanceData: () => set({ numberPerformanceData: null }),
}));
